import './App.css';
import { Routes, Route } from "react-router-dom";
import Home from './components/Home/Home'
import Films from './components/roots/Films/Films'
import People from './components/roots/People/People'
import Planets from './components/roots/Planets/Planets'
// import Starship from './components/roots/Starship/Starship';


function App() {
  return (
    <div className="App">
      <Routes> 
            <Route path='/' element={<Home/>} />
            <Route path='/films' element={<Films/>} />
            <Route path='/people' element={<People/>} />
            <Route path='/planets' element={<Planets/>} />
            {/* <Route path='/spaceships' element={<Starship/>} /> */}
      </Routes>
    </div>
  );
}

export default App;
